import React, { useEffect, useState } from 'react';
import { Button, Input, Space } from 'antd';
import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';
import { getQueryString } from 'utils/utils';
import { LecturerGubun, RefCode } from 'components/TableSearchBox';
import { addNewSearch } from 'utils/utils';
import 'components/TableSearchBox/index.scss';

const cx = classNames.bind('./index.scss');
export interface LecturerSearchBox {}

const LecturerSearchBox = ({}: LecturerSearchBox): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
  const navigate = useNavigate();
  const location = useLocation();

  /* ======================================================
   * variables
   * ====================================================== */

  /* ======================================================
   * states
   * ====================================================== */
  const [searchInput, setSearchInput] = useState<string>('');
  const [searchType, setSearchType] = useState<string|undefined>(undefined);
  const [searchCategory, setSearchCategory] = useState<string|undefined>(undefined);

  /* ======================================================
   * events
   * ====================================================== */
  const onChange = (e) => {
    setSearchInput(e.target.value);
  };

  const onClickReset = (e) => {
    setSearchInput('');
    setSearchType(undefined);
    setSearchCategory(undefined);
    navigate(location.pathname);
  };

  const onSearch = (value: string) => {
    navigate({
      ...location,
      search: addNewSearch(location.search, { search: value, pageNo: 1 }),
    });    
  };

  const onChangeType = (value: string) => {
    navigate({
      ...location,
      search: addNewSearch(location.search, { lecturer_type: value, pageNo: 1 }),
    });      
  };

  const onChangeCategory= (value: string) => {
    navigate({
      ...location,
      search: addNewSearch(location.search, { lecturer_category: value, pageNo: 1 }),
    });      
  };  
  /* ======================================================
   * effects
   * ====================================================== */

  useEffect(() => {
    const historySearch = getQueryString(location.search);
    if (historySearch.search) setSearchInput(historySearch.search);
    if (historySearch.lecturer_type) setSearchType(historySearch.lecturer_type);
    if (historySearch.lecturer_category) setSearchCategory(historySearch.lecturer_category);
  }, [location.search]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div className={cx('tableSearchBoxWrapper')}>
      <Space>
        <LecturerGubun lecturerGubun={searchType} onLecturerGubun={onChangeType}/>
        <RefCode codeValue={searchCategory} fieldName={'lecturer_category1'} placeholder={'강사분류'} onChangeSelect={onChangeCategory} />
        <Input.Search
          className={cx('searchInput')}
          value={searchInput}
          placeholder="검색어를 입력해 주세요"
          onChange={onChange}
          onSearch={onSearch}
          allowClear
        />
        <Button onClick={onClickReset}>
          검색초기화
        </Button>                
      </Space>
    </div>
  );
};

export default LecturerSearchBox;
